module.exports = __webpack_public_path__ + "static/q11_x-cd4efecb3a7e93e2f5967ea09f9fb304.png";